import { render, staticRenderFns } from "./deatils.vue?vue&type=template&id=84e63d90&scoped=true"
import script from "./deatils.vue?vue&type=script&lang=js"
export * from "./deatils.vue?vue&type=script&lang=js"
import style0 from "./deatils.vue?vue&type=style&index=0&id=84e63d90&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e63d90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84e63d90')) {
      api.createRecord('84e63d90', component.options)
    } else {
      api.reload('84e63d90', component.options)
    }
    module.hot.accept("./deatils.vue?vue&type=template&id=84e63d90&scoped=true", function () {
      api.rerender('84e63d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/playConfig/StrategyConfig/deatils.vue"
export default component.exports